import React, {useState} from "react";
import drop from "./assets/drop.png";
import coin from "../../Pages/Home/CardsStatusSection/assets/coin.png";
import { NavLink } from "react-router-dom";
const ViewModal = ({
  wrapClassName,
  setOpen,
  open,
  className,
  contentWrapClassName,
}) => {
  const handleWrapClick = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        onClick={handleWrapClick}
        className={`absolute z-10  bottom-0 left-0 group-hover:visible invisible flex opacity-0 group-hover:opacity-100 duration-10000 ation justify-center items-center scale-90 group-hover:scale-100 transition-all   ${className}`}
      >
        <div
          className={`bg-[#09090A] md:min-w-[350px]   h-[270px]  rounded-[20px] ${wrapClassName}`}
        >
          <div className="w-[156px] mt-[23px] bg-main-green h-[30px] text-res-xs font-semibold rounded-r-[20px] flex items-center text-main-black ">
            <h3 className="pl-[28px]">Tokens Vested</h3>
          </div>
          <div
            className={`mt-[24px] ml-[28px]  pr-[28px] w-[290px] items-start justify-center flex flex-col gap-[8px] h-[115px] overflow-y-scroll overflow-x-hidden viewModal ${contentWrapClassName}`}
          >
            <div className="flex gap-x-[12px]">
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={drop} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={drop} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
            </div>
            <div className="flex gap-x-[12px]">
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={coin} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={coin} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
            </div>
            <div className="flex gap-x-[12px]">
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={coin} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={drop} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
            </div>
            <div className="flex gap-x-[12px]">
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={coin} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={drop} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
            </div>
            <div className="flex gap-x-[12px]">
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={coin} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={drop} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
            </div>
            <div className="flex gap-x-[12px]">
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={coin} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={drop} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
            </div>
            <div className="flex gap-x-[12px]">
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={coin} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
              <div className="flex gap-[8px] items-center h-[32px]">
                <img className="w-[32px] h-[32px]" src={drop} alt="" />
                <h2 className="text-res-xs leading-[22px]">2,638,478.83</h2>
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-[12px]">
            <NavLink to={"/nft-details"}>
              <button className="border border-white rounded-[40px] w-[144px] font-bold text-[10px] h-[34px]">
                View More
              </button>
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewModal;
